/** URL handled by Electron with range-capable streaming and root containment. */
export function nativeWorkspaceMediaUrl(workspaceRoot: string, path: string): string {
  const params = new URLSearchParams({ root: workspaceRoot, path });
  return `crowdex-workspace://media?${params.toString()}`;
}
